










import { defineComponent, computed, onBeforeMount } from '@vue/composition-api';
import ChannelCouponDialog from './channel-coupon-dialog.vue';
import { ensureChannelCouponId } from '@/utils/channel-coupon';
import { biClick, biBrow } from '@tencent/fit-bi-sdk';
import { useChannelCouponDialog, ChannelKey } from './use-channel-coupon-dialog';

export default defineComponent<{
  channelKey: ChannelKey,
  channelTagText: string,
}>({
  components: {
    ChannelCouponDialog,
  },
  props: {
    /**
         * 投放渠道id，这个id将会作为从url中取参数的key，例如URL为 ?spPrize=xxx 中 spPrize 就是 channelKey
         */
    channelKey: {
      type: String,
      default: '',
    },
    /**
         * 该渠道分发时，给coupon打的特殊tag的文案
         */
    channelTagText: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const couponId = ensureChannelCouponId(props.channelKey);
    const { isShowDialog } = useChannelCouponDialog();
    const isShow = computed(() => isShowDialog(ChannelKey.ScanForPerks));

    const biExt = { fcouponid: couponId as string, fchannelkey: props.channelKey };

    onBeforeMount(() => {
      biBrow('channel_coupon.dialog_brow', biExt);
    });

    const onExchPrize = () => {
      biClick('channel_coupon.exch_prize|渠道专享券兑换', biExt);
    };

    const onClose = () => {
      biClick('channel_coupon.dialog_close|渠道专享券弹窗关闭', biExt);
    };

    return {
      couponId,
      isShow,
      onExchPrize,
      onClose,
    };
  },
});
